import React, { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Upload, Loader2 } from "lucide-react";

// Template download + Excel bulk-upload of requests for one engagement.
export function ImportExcel({ engId, onDone }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const downloadTemplate = async () => {
    try {
      const r = await api.get("/m1/requests/template", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a");
      a.href = url; a.download = "azexpan_requests_template.xlsx";
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiError(e)); }
  };

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/m1/engagements/${engId}/requests/import`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const { created, skipped, errors } = r.data;
      toast.success(`Imported ${created} request(s)${skipped ? `, skipped ${skipped}` : ""}`);
      if (errors?.length) toast.warning(`${errors.length} row issue(s): ${errors[0]}`);
      onDone && onDone();
    } catch (er) { toast.error(apiError(er)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" onClick={downloadTemplate} data-testid="download-template-btn">
        <Download className="mr-2 h-4 w-4" /> Template
      </Button>
      <Button variant="outline" onClick={() => fileRef.current?.click()} disabled={busy} data-testid="upload-requests-btn">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Upload className="mr-2 h-4 w-4" />} Upload requisition
      </Button>
      <input ref={fileRef} type="file" accept=".xlsx" className="hidden" onChange={onFile} data-testid="upload-requests-input" />
    </>
  );
}
